// import { OverridableStringUnion } from '@mui/types';

import { IEBreakPoints } from './@types';

const breakPoints: { [key in IEBreakPoints]: number } = {
  [IEBreakPoints.XS]: 0,
  [IEBreakPoints.SM]: 600,
  [IEBreakPoints.MD]: 900,
  [IEBreakPoints.LG]: 1200,
  [IEBreakPoints.XL]: 1536,
  [IEBreakPoints.MOBILE]: 0,
  [IEBreakPoints.TABLET]: 640,
  [IEBreakPoints.LAPTOP]: 1024,
  [IEBreakPoints.DESKTOP]: 1200,
};

export default breakPoints;
